import { Box, Button, styled } from "@material-ui/core";
import { LockOutlined } from "@material-ui/icons";
import { memo } from "react";
import {
  EPOCUS_BORDER,
  EPOCUS_PRIMARY,
  EPOCUS_STATUS_DRAFT_BG,
  EPOCUS_STATUS_DRAFT_TEXT,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../../_lib/epocus-palette";

const Card = styled(Box)({
  marginLeft: 38,
  backgroundColor: EPOCUS_WHITE,
  border: `1px solid ${EPOCUS_BORDER}`,
  borderRadius: 12,
  padding: 16,
  display: "flex",
  flexDirection: "column",
  gap: 12,
});

const Prompt = styled("p")({
  margin: 0,
  fontSize: rem(15),
  lineHeight: 1.5,
  fontWeight: 700,
  color: EPOCUS_TEXT_PRIMARY,
});

const IrreversibleNote = styled(Box)({
  display: "flex",
  gap: 8,
  alignItems: "flex-start",
  backgroundColor: EPOCUS_STATUS_DRAFT_BG,
  border: `1px solid ${EPOCUS_BORDER}`,
  borderRadius: 8,
  padding: "8px 10px",
  fontSize: rem(12),
  lineHeight: 1.45,
  color: EPOCUS_STATUS_DRAFT_TEXT,
});

const Actions = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
});

const Answered = styled("p")({
  margin: 0,
  fontSize: rem(13),
  color: EPOCUS_TEXT_SECONDARY,
});

const ActionButton = styled(Button)({
  minHeight: 44,
  textTransform: "none",
  fontWeight: 700,
  borderRadius: 10,
});

export const ConfirmationCard = memo<{
  prompt: string;
  reason?: string;
  confirmLabel: string;
  declineLabel: string;
  answered?: boolean;
  approved?: boolean;
  disabled: boolean;
  onRespond: (approved: boolean) => void;
}>(
  ({
    prompt,
    reason,
    confirmLabel,
    declineLabel,
    answered,
    approved,
    disabled,
    onRespond,
  }) => {
    return (
      <Card role="group" aria-label="Confirmation required">
        <Prompt>{prompt}</Prompt>
        {reason && (
          <IrreversibleNote>
            <LockOutlined style={{ fontSize: 16, color: EPOCUS_PRIMARY }} />
            <span>{reason}</span>
          </IrreversibleNote>
        )}
        {answered ? (
          <Answered>
            {approved
              ? `You chose "${confirmLabel}".`
              : `You chose "${declineLabel}".`}
          </Answered>
        ) : (
          <Actions>
            <ActionButton
              variant="contained"
              color="primary"
              disableElevation
              disabled={disabled}
              onClick={() => onRespond(true)}
            >
              {confirmLabel}
            </ActionButton>
            <ActionButton
              variant="outlined"
              color="primary"
              disableElevation
              disabled={disabled}
              onClick={() => onRespond(false)}
            >
              {declineLabel}
            </ActionButton>
          </Actions>
        )}
      </Card>
    );
  },
);
ConfirmationCard.displayName = "ConfirmationCard";
